import React from 'react'
import { t } from 'ttag'
import styles from './AdminHeader.module.scss'
import { Combobox } from 'components/shared/FormFields/common/Combobox/Combobox'
import type { ComboboxOption } from 'components/shared/FormFields/common/Combobox/types'
import { fetchDepartments } from 'api/departments'
import { Icon, Edit3Icon } from 'components/shared/Icon/Icon'
import { components } from 'react-select'
import { PlusCircleIcon } from 'components/shared/Icon/model'

const insert = newStyles => baseStyles => ({
  ...baseStyles,
  ...newStyles,
})

const DropdownIndicator = props => {
  return (
    <components.DropdownIndicator {...props}>
      <Icon icon={PlusCircleIcon} size={22} className={styles.icon} />
    </components.DropdownIndicator>
  )
}

export const AdminHeader = ({
  selectedUser,
  addUserDepartment,
  handleManageUserOpen,
}) => (
  <div className={styles.adminHeader}>
    {selectedUser ? (
      <>
        <div className={styles.userName}>
          {`${selectedUser.first_name} ${selectedUser.last_name}`}{' '}
          <span className={styles.editUser} onClick={handleManageUserOpen}>
            <Icon icon={Edit3Icon} size={22} />
          </span>
        </div>
        <div className={styles.inputContainer}>
          <Combobox
            placeholder={t`Add Department`}
            isSearchable
            noOptionsMessage={t`All departments added`}
            // react-select passes the loaded option under `data`
            filterOption={(option: ComboboxOption & { data?: any }) =>
              !option.data.users.includes(selectedUser.id)
            }
            styles={{
              valueContainer: insert({
                padding: '6px 6px 6px 12px !important',
              }),
              container: insert({
                display: 'flex',
                alignItems: 'center',
              }),
              control: insert({
                borderColor: '#bbb !important',
              }),
              placeholder: insert({
                color: '#0091c2 !important',
                fontWeight: '500 !important',
              }),
            }}
            customComponents={{ DropdownIndicator }}
            fetchOptions={[
              fetchDepartments,
              ({ name, id, users }) => ({
                label: name,
                value: id,
                users: users.map(user => user.id),
              }),
            ]}
            {...{
              value: null,
              onChange: (option: any) => addUserDepartment(option.value),
            }}
          />
        </div>
      </>
    ) : null}
  </div>
)
